import { supabase } from "@/lib/supabase/supabaseClient";
import { TablesInsert } from "@/lib/supabase/supabase_types_override";

export const createOrganization = async (data: TablesInsert<'organisation'> | TablesInsert<'organisation'>[]) => await supabase.from('organisation').insert(data).throwOnError().select().then(res => res.data);